import { fuzzyMatch } from './licensingSearch';

// The filters that run in the browser (QW-453, FR-LPAY-16, BR-LPAY-2): Payee Name and Paid / Not Paid.

type TCheck = { paid?: boolean; void?: boolean };
type TRow = { payees?: Array<{ name?: string; checks?: TCheck[] }> };
export type TClientFilters = { payeeName?: string; paid?: 'paid' | 'notPaid' | null };

// A row is Paid when every one of its non-void checks is Paid; a row with no such check is Not Paid.
export function rowPaid(row: TRow): boolean {
  const checks = (row.payees || []).flatMap((p) => p.checks || []).filter((c) => !c.void);
  return checks.length > 0 && checks.every((c) => c.paid);
}

export function filterRows<T extends TRow>(rows: T[], filters: TClientFilters): T[] {
  const name = (filters.payeeName || '').trim();
  return rows.filter((r) => {
    if (filters.paid && rowPaid(r) !== (filters.paid === 'paid')) return false;
    if (name && !(r.payees || []).some((p) => p.name === name || fuzzyMatch(p.name || '', name))) return false;
    return true;
  });
}

// Whether any filter is applied, for the filter button's filled state.
const FILTER_KEYS = ['tracks', 'licensors', 'status', 'payeeName', 'paid'];

export function hasFilters(filters: Record<string, unknown>): boolean {
  return FILTER_KEYS.some((k) => {
    const v = filters[k];
    return Array.isArray(v) ? v.length > 0 : Boolean(v);
  });
}

// The Payee Name filter's options: every payee name on the licensing rows already loaded, once each,
// alphabetically (the prototype's dropdown).
export function payeeNameOptions(bundles: Array<{ payees?: Array<{ name?: string }> }>): string[] {
  const names = bundles.flatMap((b) => (b.payees || []).map((p) => p.name)).filter(Boolean);
  return [...new Set(names)].sort((a, b) => a.localeCompare(b));
}
